/**
 * RESPONSIBILITY: draw the mark a welcome tag asks for.
 *
 * Artwork, not content: the tag's words come from its row, the drawing is chosen from a
 * fixed set by name. Same arrangement as the footer's social marks.
 */
import { WELCOME_MARK } from '@app/sections';

const PATHS: Record<string, React.ReactNode> = {
  [WELCOME_MARK.Refreshments]: (
    <path d="M18 8h1a4 4 0 0 1 0 8h-1M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8zM6 1v3M10 1v3M14 1v3" />
  ),
  [WELCOME_MARK.Children]: (
    <>
      <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z" />
      <path d="M9 10h.01M15 10h.01M9.5 15a3.5 3.5 0 0 0 5 0" />
    </>
  ),
  [WELCOME_MARK.Parking]: (
    <>
      <rect x="1" y="3" width="15" height="13" />
      <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
      <circle cx="5.5" cy="18.5" r="2.5" />
      <circle cx="18.5" cy="18.5" r="2.5" />
    </>
  ),
};

export function WelcomeMark({ name }: { name: string | undefined }) {
  const shape = PATHS[name ?? ''];
  if (!shape) return null;

  return (
    <svg
      className="join-tag-icon" width="18" height="18" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true" focusable="false"
    >
      {shape}
    </svg>
  );
}
